<!-- Barra superior -->
  <mat-toolbar color="primary" class="navbar">
    <span class="logo">
      <a (click)="goToHome()" style="cursor: pointer;">
        PRAD Academy
      </a>
    </span>
    <span class="spacer"></span>

    <!-- Enlaces visibles solo en escritorio -->
    <div class="nav-links">
      <button mat-button (click)="actionHome()">{{ 'LANDING.NAVBAR_TEXT_START' | translate }}</button>
      <button mat-button matTooltip="{{ 'LANDING.NAVBAR_TEXT_FEEDBACK_TOOLTIP' | translate }}" (click)="actionFeedback()">{{ 'LANDING.NAVBAR_TEXT_FEEDBACK' | translate }}</button>
      <button mat-stroked-button color="accent" (click)="actionLogin()" matTooltip="{{ 'LANDING.NAVBAR_TEXT_LOGIN' | translate }}">
        <mat-icon>login</mat-icon> {{ 'LANDING.NAVBAR_TEXT_LOGIN' | translate }}
      </button>
      <button mat-raised-button color="accent" (click)="actionRegister()" matTooltip="{{ 'REGISTER.TOOLTIP' | translate }}">
        <mat-icon>person_add</mat-icon> {{ 'LANDING.NAVBAR_TEXT_REGISTER' | translate }}
      </button>
    </div>   
  

    <div class="nav-button">
      
      <div class="example-button-row">
    <div class="example-flex-container">
      <button matMiniFab (click)="actionFeedback()" matTooltip="{{ 'LANDING.NAVBAR_TEXT_FEEDBACK_TOOLTIP' | translate }}">
        <mat-icon style="margin-right: 0;">email</mat-icon>
      </button>
      <button matMiniFab (click)="actionLogin()" matTooltip="{{ 'LOGIN.TOOLTIP' | translate }}">
        <mat-icon>login</mat-icon>
      </button>
      <button matMiniFab (click)="actionRegister()" matTooltip="{{ 'REGISTER.TOOLTIP' | translate }}">
        <mat-icon>person_add</mat-icon>
      </button>
    </div>
  </div>

    </div>

    <!--<app-language-switcher style="margin-left: 10px;"></app-language-switcher>-->

  </mat-toolbar>

